import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';

/**
 * Sticky bottom CTA. Appears once the user scrolls past the hero CTA
 * (element with id="hero-cta") and shakes to draw attention.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const update = () => {
      const rect = anchor.getBoundingClientRect();
      setVisible(rect.bottom < 0);
    };
    update();
    window.addEventListener('scroll', update, {
      passive: true
    });
    window.addEventListener('resize', update);
    return () => {
      window.removeEventListener('scroll', update);
      window.removeEventListener('resize', update);
    };
  }, []);
  return <AnimatePresence data-id="element-32" data-mp="14fq5jhvwkett">
      {visible ? <motion.div initial={{
      opacity: 0,
      y: 24
    }} animate={{
      opacity: 1,
      y: 0
    }} exit={{
      opacity: 0,
      y: 24
    }} transition={{
      duration: 0.22,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 border-t border-teal-400/20 bg-ink-900/95 px-4 pb-4 pt-3 backdrop-blur-sm" data-id="element-33" data-mp="14dvk82gpykp7">
          <div className="mx-auto flex max-w-md flex-col items-center" data-id="element-34" data-mp="26bqn2mfvee58">
            <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2 rounded-2xl bg-teal-400 px-5 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-ink-900 shadow-[0_10px_30px_-10px_rgba(37,201,204,0.8)] transition-colors duration-150 ease-out hover:bg-teal-300 sm:text-base" data-id="element-35" data-mp="269mcxmrdoiwi">
              Get The Master System — $27
              <ArrowRightIcon className="h-4 w-4 shrink-0" aria-hidden="true" data-id="element-36" data-mp="3crszjc4okb0x" />
            </a>
            <p className="mt-2 text-center text-[10px] font-semibold uppercase tracking-[0.14em] text-teal-200/70" data-id="element-37" data-mp="3hqvug3qy50v6">
              One-time payment · Instant access · 7-day guarantee
            </p>
          </div>
        </motion.div> : null}
    </AnimatePresence>;
}